export default {
  xs: 1,
  sm: 1.2,
  md: 1.5,
  lg: 2
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/lineHeight/index.js
// module id = 1774
// module chunks = 12